// This icon file is generated automatically.
var PSmileOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M3.5 5.58a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm5.5 0a.75.75 0 101.5 0 .75.75 0 00-1.5 0zM7 0a7 7 0 100 14A7 7 0 007 0zm4.1 11.1a5.81 5.81 0 11-8.22-8.2 5.81 5.81 0 018.23 8.2zM9.39 7.34h-.76a.13.13 0 00-.12.11 1.5 1.5 0 01-3 0 .13.13 0 00-.12-.11h-.75a.12.12 0 00-.13.13 2.5 2.5 0 005 0 .12.12 0 00-.13-.13z", "fill-rule": "nonzero" } }] }, "name": "p-smile", "theme": "outlined" };
export default PSmileOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PSmileOutlined.js
// module id = 3638
// module chunks = 0